import { NavLink, Outlet } from "react-router";
import { useEffect } from "react";

import { LinkPrimaryArrow } from "components/link/Link";
import { SideMenu } from "components/menu/SideMenu/SideMenu";
import { useGlobalContext } from "app/store/GlobalContext";
import { useRootStore } from "store";

export default function Inbox() {
  const { handleNavigation } = useGlobalContext();

  const { resetInbox, fetchSentMessages } = useRootStore(
    (state) => state.inbox
  );

  const { user, archive } = useRootStore((store) => store);
  const workingCustomerId = useRootStore(
    (store) => store.global.workingCustomerId
  );

  const { fetchArchiveFolders } = archive;

  const isInternalUser = user.userInfo && user.userInfo.type === "Internal";

  useEffect(() => {
    resetInbox();

    if (!workingCustomerId) {
      return;
    }
    fetchSentMessages(workingCustomerId);
    fetchArchiveFolders(workingCustomerId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workingCustomerId]);

  return (
    <>
      <div className="d-flex flex-wrap align-items-start">
        <SideMenu title={<>Inkorg</>}>
          <div className="d-flex flex-wrap">
            <div className="d-flex flex-direction-column align-items-start mr-relative">
              <LinkPrimaryArrow
                className="my-4"
                to={"/inbox/newThread"}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation({
                    url: "/inbox/newThread",
                    eventTitle: "Ny konversation",
                    e: e
                  });
                }}
              >
                Ny konversation
              </LinkPrimaryArrow>
              <NavLink
                className={`side-menu-link mt-4`}
                to={"/inbox/my"}
                onClick={(e) => {
                  handleNavigation({
                    url: "/inbox/my",
                    eventTitle: "Mina konversationer",
                    e: e
                  });
                }}
              >
                Mina konversationer
              </NavLink>
              {isInternalUser && (
                <NavLink
                  className="side-menu-link"
                  to={"/inbox/all"}
                  onClick={(e) => {
                    handleNavigation({
                      url: "/inbox/all",
                      eventTitle: "Alla konversatione",
                      e: e
                    });
                  }}
                >
                  Alla konversationer
                </NavLink>
              )}
              <NavLink
                className={`side-menu-link mt-4`}
                to={"/inbox/sent"}
                onClick={(e) =>
                  handleNavigation({
                    url: "/inbox/sent",
                    eventTitle: "Skickade meddelanden",
                    e: e
                  })
                }
              >
                Skickade meddelanden
              </NavLink>
            </div>
          </div>
        </SideMenu>

        <div className="w-100 flex-1-1 box">
          <Outlet />
        </div>
      </div>
    </>
  );
}
